import { persist } from "zustand/middleware";
import { create } from "zustand/react";

type EnterpriseStore = {
  currentEnterpriseId: string | null;
  currentEnterpriseUserId: string | null;
  setCurrentEnterpriseId: (enterpriseId: string, userId: string) => void;
};

export const useEnterpriseStore = create<EnterpriseStore>()(
  persist(
    (set) => ({
      currentEnterpriseId: null,
      currentEnterpriseUserId: null,
      setCurrentEnterpriseId: (enterpriseId, userId) => {
        set({
          currentEnterpriseId: enterpriseId,
          currentEnterpriseUserId: userId,
        });
      },
    }),
    { name: "colmeia-enterprise" },
  ),
);
